import React from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox, Badge } from '../components/Card';
import { COMPOUND_NUMS } from '../utils/data';

export default function CompoundScreen() {
  return (
    <div>
      <QuoteBox text="الأرقام المركبة ليست مجرد أرقام... إنها رسائل، ومفاتيح، وإشارات تحمل توجيهات" src="جذر الفلك، الجزء الأول" />
      <Card>
        <CardTitle>الأرقام المركبة</CardTitle>
        {COMPOUND_NUMS.map(cn => (
          <RCard key={cn.n} style={{marginBottom:12}}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8,display:'flex',alignItems:'center',gap:8}}>
              <strong style={{fontSize:20,fontFamily:'Amiri,serif',color:'#F0C96A'}}>{cn.n}</strong>
              — {cn.title} <Badge>{cn.src}</Badge>
            </div>
            <div style={{fontSize:14,lineHeight:1.75}}>{cn.desc}</div>
          </RCard>
        ))}
      </Card>
    </div>
  );
}
